import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutGrid, Users } from 'lucide-react';

export interface BrandTabItem {
  id: string; // '' means All Brands
  name: string;
  logo?: string;
}

interface BrandTabsProps {
  activeBrandId: string; // '' for All
  onBrandChange: (brandId: string) => void;
  brands: BrandTabItem[];
}

export const BrandTabs: React.FC<BrandTabsProps> = ({ activeBrandId, onBrandChange, brands }) => {
  const { t } = useTranslation();
  const items: BrandTabItem[] = [{ id: '', name: t('brandDropdown.allBrands', 'All Brands') }, ...brands];
  return (
    <div className="mb-4 overflow-x-auto">
      <div className="flex border-b border-gray-200 min-w-max lg:min-w-0">
        {items.map((b) => (
          <button
            key={b.id || 'all'}
            onClick={() => onBrandChange(b.id)}
            className={`px-3 lg:px-4 py-2 font-medium text-sm flex items-center gap-2 whitespace-nowrap ${
              activeBrandId === b.id ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {b.id === '' ? (
              <>
                <LayoutGrid className="w-4 h-4" />
                <span className="hidden lg:inline">{b.name}</span>
              </>
            ) : b.logo ? (
              <>
                <img src={b.logo} alt={b.name} className="w-4 h-4 rounded object-cover" />
                <span className="hidden lg:inline">{b.name}</span>
              </>
            ) : (
              <>
                <Users className="w-4 h-4" />
                <span className="hidden lg:inline">{b.name}</span>
              </>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BrandTabs;


